'use client';

import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';
import { useEffect } from 'react';

export const ArticleServicesTestTracking = () => {
  const { setOutcome } = useAbTesting();

  const testId =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
      ? '2025_04_Aplus_reco_test'
      : '2025_04_Aplus_reco';

  useEffect(() => {
    setOutcome(testId, {
      DV_APLUS: 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
